import React from 'react';

export const BlockPagePreview = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'block-page-preview' */
            './BlockPagePreview'
        ),
);
